import { formatDate } from '@utils/time-utils';

export type productInfoItem = {
  productName?: string;
}
export type MainOrderItem = {
	orderStatus?: string; // todo 值和原来不一致
	orderNo?: string;
	orderTime?: string;
	orderContent?: string; // 前端根据productInfoDto里的数组，组装出来的
  productInfoDto?: productInfoItem[];
	paymentCurrency?: string; // 币种
	orderAmount?: string;
  subList?: SubOrderItem[];
}
export type SubOrderItem = {
  subOutTradeNo?: string;
  payAmount?: number;
  canPaid?: boolean; // todo 什么时候展示子订单支付按钮
}

export function getAgeOrBirth (age: number | string | undefined, birth: string | undefined): string {
	if (age) {
		return formatDate(new Date(new Date().getFullYear() - Number(age), 6, 1), 'YYYY-MM-DD') || ''
	}
	if (birth) {
		const tempY = Number(birth.split('-')[0])
		return (new Date().getFullYear() - tempY) + ''
	}
	return ''
}
